import { Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { MenuItem } from '../../core/models/interfaces-general';
import { Constante } from '../../constante';
import { AuthService } from '../../core/services/auth.service';
import { CarritoService } from '../../services/carrito-service';
import { CartService } from '../../services/cart.service';

@Component({
    selector: 'app-header',
    standalone: true,
    imports: [CommonModule,
        FormsModule,
        RouterLink],
    templateUrl: './header.html'
})
export class HeaderComponent {
    // Entradas configurables
    @Input() logoUrl: string = 'logo-rosaline-blanco.png';
    @Input() menuItems: MenuItem[] = [];
    @Input() cartCount: number = 0;

    private carritoService = inject(CarritoService)
    cartService = inject(CartService)
    // Estado del menú móvil
    isMobileMenuOpen: boolean = false;
    openMobileSubmenu: string | null = null;
    openMobileSubSubmenu: string | null = null;

    // Estado para el buscador
    searchQuery: string = '';
    userMenuOpen = false;
    private router = inject(Router);
    auth = inject(AuthService);

    toggleMobileMenu() {
        this.isMobileMenuOpen = !this.isMobileMenuOpen;
    }

    toggleMobileSubmenu(label: string) {
        this.openMobileSubmenu = this.openMobileSubmenu === label ? null : label;
        this.openMobileSubSubmenu = null;
    }

    toggleMobileSubSubmenu(label: string) {
        this.openMobileSubSubmenu = this.openMobileSubSubmenu === label ? null : label;
    }

    onSearch() {
        const key = this.searchQuery.trim();
        this.router.navigate([Constante.URL_CATALOGO], {
            queryParams: key ? { key } : {}
        });
        this.isMobileMenuOpen = false;
    }

    onUserClick() {
        if (!this.auth.isAuthenticated()) {
            this.router.navigate([Constante.URL_LOGIN]);
            return;
        }
        this.userMenuOpen = !this.userMenuOpen;
    }

    goAdmin() {
        this.userMenuOpen = false;
        this.router.navigate([Constante.URL_ADMIN]);
    }

    goSeguimiento() {
        this.router.navigate([Constante.URL_SEGUIMIENTO]);
    }

    logout() {
        this.userMenuOpen = false;
        this.auth.logout();
        this.router.navigate([Constante.URL_HOME]);
    }
    toggleCart() {
        this.carritoService.show()
    }
}